
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/partner-pre-registrations",
      function () {
        return require("private-next-pages/admin/partner-pre-registrations/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/partner-pre-registrations"])
      });
    }
  